import React, { Component } from 'react';
import Tools from '../../tools';
import API from '../../api.js';
import ItemView from '../utils/ItemView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from '../../enums';
import {Link} from 'react-router-dom';

class AdsDetailApp extends React.Component {
    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        console.log(this.props);
        this.state = {
            ty: 1,
            list: [],
            id: this.props.match.params["id"]  || "",
        };
        this.getData();
        this.onItemViewUpdated = this.onItemViewUpdated.bind(this);
        this.onSave = this.onSave.bind(this);
        // this.onAdClicked = this.onAdClicked.bind(this);
        // this.onItemViewUpdated = this.onItemViewUpdated.bind(this);
    }
    
    // componentDidMount () {
    //     const { handle } = this.props.match.params
    // }

    getData() {
        var tmpData = {
            ty: this.state.ty,
            adi: this.state.id,
        };
        API.GetAds(tmpData, this.onDataUpdated.bind(this));
    }

    onItemViewUpdated(index, value){
        // console.log(index, value);
        let list = Object.assign({}, this.state.list);
        list[index].data.value=value;
        this.setState({list:list});
    }

    onDataUpdated(data) {
        console.log(this);
        if (data && data.data && data.data.length > 0) {
            /*{
                "data": [
                    {
                    "end_at": "1561910400000",
                    "is_recom": "0",
                    "ad_type": "3",
                    "link": "none",
                    "total_members": 1,
                    "video": "none",
                    "start_at": "1543104000000",
                    "point": "0",
                    "is_del": "0",
                    "total_clicks": 3,
                    "sub_name": "none",
                    "name": "歡樂美味盡在EZChoice",
                    "cash_point": "0",
                    "is_top": "0",
                    "add_desc": "none",

                    "created_at": "1543563890473",
                    "gid": "GL181018163502",
                    "icon": "gifts/261/cgqt1paxiscbrc2tcyca6xzixn0pkigl.jpg",
                    "images": [],
                    "images2": [],
                    "description": "none",
                    "pid": "none",
                    "source": "dataa",
                    "type": "1",
                    "has_video": "0",
                    "adid": "AD181130154450",
                    "updated_at": "1543563890473",
                    "created_id": "admin",
                    "updated_id": "admin"
                    }
                ]
            }*/

            const tmpObj = data.data[0];
            const tmp = [
                {
                    type: Enums.E_ITEM.NUMBER,
                    data: {
                        label:'總點擊次數',
                        editable: false,
                        value:tmpObj.total_clicks
                    }
                },{
                    type: Enums.E_ITEM.NUMBER,
                    col:1,
                    data: {
                        label:'總觸及次數',
                        editable: false,
                        value:tmpObj.total_members
                    }
                },{
                    type: Enums.E_ITEM.OPTION,
                    data: {
                        label:'廣告類型',
                        neccessary: true,
                        options: [[0,"0?"], [1,"1?"]],
                        value:tmpObj.ad_type
                    }
                },{
                    type: Enums.E_ITEM.NUMBER,
                    col:1,
                    data: {
                        label:'贈送E幣',
                        value:tmpObj.point
                    }
                },{
                    type: Enums.E_ITEM.TEXT,
                    data: {
                        label:'廣告標題',
                        neccessary: true,
                        value:tmpObj.name
                    }
                },{
                    type: Enums.E_ITEM.NUMBER,
                    col:1,
                    data: {
                        label:'贈送金幣',
                        value:tmpObj.cash_point
                    }
                },{
                    type: Enums.E_ITEM.TEXT,
                    data: {
                        label:'廣告副標題',
                        neccessary: true,
                        value:tmpObj.sub_name
                    }
                },{
                    type: Enums.E_ITEM.TEXT,
                    col:1,
                    data: {
                        label:'影片連結',
                        value:tmpObj.video
                    }
                },{
                    type: Enums.E_ITEM.TIME,
                    data: {
                        label:'上架日期',
                        neccessary: true,
                        value:tmpObj.start_at
                    }
                },{
                    type: Enums.E_ITEM.TEXT,
                    col:1,
                    data: {
                        label:'跳轉目的地',
                        value:tmpObj.link
                    }
                },{
                    type: Enums.E_ITEM.TIME,
                    data: {
                        label:'下架日期',
                        neccessary: true,
                        value:tmpObj.end_at
                    }
                },{
                    type: Enums.E_ITEM.TEXTAREA,
                    col:1,
                    data: {
                        label:'廣告主文',
                        neccessary: true,
                        value:tmpObj.description
                    }
                },{
                    type: Enums.E_ITEM.RADIO,
                    col:1,
                    data: {
                        label:'置頂',
                        options: [ [1,"是"], [0,"否"] ],
                        value:tmpObj.is_top
                    }
                },{
                    type: Enums.E_ITEM.RADIO,
                    col:1,
                    data: {
                        label:'強力推薦',
                        options: [ [1,"是"], [0,"否"] ],
                        value:tmpObj.is_recom
                    }
                },{
                    type: Enums.E_ITEM.RADIO,
                    col:1,
                    data: {
                        label:'刪除',
                        options: [ [1,"是"], [0,"否"] ],
                        value:tmpObj.is_del
                    }
                },{
                    type: Enums.E_ITEM.IMAGE,
                    data: {
                        label:'廣告主圖',
                        neccessary: true,
                        value:tmpObj.icon
                    }
                },{
                    type: Enums.E_ITEM.TEXTAREA,
                    col:1,
                    data: {
                        label:'廣告補充內容',
                        value:tmpObj.add_desc
                    }
                },{
                    type: Enums.E_ITEM.IMAGE,
                    data: {
                        label:'廣告附圖',
                        value:tmpObj.images
                    }
                },{
                    type: Enums.E_ITEM.IMAGE,
                    data: {
                        label:'廣告主文圖',
                        value:tmpObj.images2
                    }
                },{
                    type: Enums.E_ITEM.TEXT,
                    col:1,
                    data: {
                        label:'來源',
                        neccessary: true,
                        value:tmpObj.source
                    }
                }
            ];

            this.setState({
                list: tmp
            })
        }
    }

    checkNecessary(){
        let list = Object.assign({}, this.state.list),
            result = true;
        for( let i in list ){
            let obj = list[i];
            delete obj.data.isError;
            if( true == obj.data.neccessary ){
                if(null==obj.data.value){
                    result = false;
                    obj.data.isError = true;
                }
                switch(obj.type){
                    case Enums.E_ITEM.TEXT:
                    case Enums.E_ITEM.TEXTAREA:
                        if( typeof(obj.data.value)!="string" ||
                            0==obj.data.value.length
                        ){
                            result = false;
                            obj.data.isError = true;
                        }
                        break;
                    case Enums.E_ITEM.TIME:
                    case Enums.E_ITEM.NUMBER:
                        if( isNaN(parseInt(obj.data.value))
                        ){
                            result = false;
                            obj.data.isError = true;
                        }
                        break;
                }
            }
        }
        this.setState({list:list});
        return result;
    }

    onSave() {
        if (false == this.checkNecessary()) {
            alert("資料錯誤");
            return;
        }

        console.log("onSave");
        const list = this.state.list;
        const header = {
            ty: 2, //功能(0=新增, 1=預覽, 2=修改)
            adi: this.state.id
        };
        const body = {
            'total_clicks': list[0].data.value,
            'total_members': list[1].data.value,
            'ad_type': list[2].data.value,
            'point': list[3].data.value,
            'name': list[4].data.value,
            'cash_point': list[5].data.value,
            'sub_name': list[6].data.value,
            'video': list[7].data.value,
            'start_at': list[8].data.value,
            'link': list[9].data.value,
            'end_at': list[10].data.value,
            'description': list[11].data.value,
            'is_top': list[12].data.value,
            'is_recom': list[13].data.value,
            'is_del': list[14].data.value,
            'icon': list[15].data.value,
            'add_desc': list[16].data.value,
            'images': list[17].data.value,
            'images2': list[18].data.value,
            'source': list[19].data.value,
        };

        console.log(header, body);
        API.AddAds(header, body, function(res){
            console.log(res);
            if( 22000 == res.code ){
                alert("更新成功");
                // location.reload();
                let path = '/#/ads/datail/' + this.state.id;
                this.props.history.push(path);
            }
        });
    }
    
    // onAdClicked(e) {
    //     e.stopPropagation();
    //     e.preventDefault();
        
    //     // location.href = "detail.html?id="+index;
    //     let path = '/#/ads/click/' + this.state.id;
    //     this.props.history.push(path);
    // }

    render() {
        const { list, fields, id } = this.state,
            {onItemViewUpdated, onSave, onAdClicked} = this;
        return (
            <div>
                <ItemView
                    title={"廣告: " + id}
                    onUpdate={onItemViewUpdated}
                    onSave={onSave}
                    disableDelete={true}
                    disablePreview={true}
                    data={list}/>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <Link className="btn btn-outline-info" to={'/ads/click/' + this.state.id}>點擊廣告名單</Link>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(AdsDetailApp),
//     document.getElementById('root')
// );


const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AdsDetailApp))